module.exports = __webpack_public_path__ + "img/actablue_newBlue.ad31087e.png";